import React from 'react';

const RadioOptionGroup = ({
    label = '',
    name,
    selectedValue,
    onChange,
    options = [],
    columns = 6, // default: 2 buttons per row
}) => {
    return (
        <div className="form-group">
            {label && (
                <label className="col-md-12 pd10botbuilder">
                    {label}
                </label>
            )}
            <div className="row">
                {options.map((option, index) => {
                    const isDisabled = !!option.disabled;
                    return (
                        <div className={`col-md-${columns}`} key={index}>
                            <div
                                className="custom-control custom-radio"
                                style={{
                                    border: selectedValue === option.value ? '1px solid rgb(15, 98, 254)' : '1px solid #e1e5e9',
                                    borderRadius: '8px',
                                    padding: '3px 3px 3px 35px',
                                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                                    backgroundColor: selectedValue === option.value ? '#f8f9ff' : 'white',
                                    transition: 'all 0.3s ease'
                                }}
                                onClick={() => !isDisabled && onChange(option.value)}
                            >
                                <input
                                    type="radio"
                                    id={`${name}_${option.value}`}
                                    name={name}
                                    className="custom-control-input"
                                    value={option.value}
                                    checked={selectedValue === option.value}
                                    onChange={(e) => !isDisabled && onChange(e.target.value)}
                                    style={{ accentColor: 'rgb(15, 98, 254)' }}
                                    disabled={isDisabled}
                                />
                                <label
                                    className="custom-control-label"
                                    htmlFor={`${name}_${option.value}`}
                                    style={{ color: '#495057', fontWeight: '600', fontSize: '16px', cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                                >
                                    {option.label}
                                </label>
                                {option.description && (
                                    <div
                                        style={{
                                            marginTop: '8px',
                                            color: '#6c757d',
                                            fontSize: '14px',
                                            minHeight: '18px'
                                        }}
                                    >
                                        {option.description}
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RadioOptionGroup;
